export const ACTUALIZAR_LIST_EPP = "ACTUALIZAR_LIST_EPP";
export const MODIFICAR_EPP = "MODIFICAR_EPP";
export const AGREGAR_EPP = "AGREGAR_EPP";
export const ELIMINAR_EPP = "ELIMINAR_EPP";
